import { IRangeValidationHandler, IValidationHandler } from '@partners/forms';
import { DateUtil } from '@partners/utils';

export const getBirthDateValidationRange = (): IRangeValidationHandler<string> => {
  return {
    min: DateUtil.dateDiff({ value: -99, unit: 'years' }, { anchorDate: new Date(), autoDay: 'today' }),
    max: DateUtil.dateDiff({ value: -18, unit: 'years' }, { anchorDate: new Date(), autoDay: 'today' })
  };
};
export const validatorTypeComparer = (a: IValidationHandler, b: IValidationHandler): boolean => {
  return a.type === b.type;
};
